import script from "./CourseDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./CourseDetailCard.vue?vue&type=style&index=0&id=9dfd28d0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dfd28d0"]])

export default __exports__